__turbopack_context__.v({
  "appBadges": "styles-module__FFjwhq__appBadges",
  "autoPlay": "styles-module__FFjwhq__autoPlay",
  "card": "styles-module__FFjwhq__card",
  "card1": "styles-module__FFjwhq__card1",
  "card2": "styles-module__FFjwhq__card2",
  "card3": "styles-module__FFjwhq__card3",
  "cardStack": "styles-module__FFjwhq__cardStack",
  "container": "styles-module__FFjwhq__container",
  "ctaWrapper": "styles-module__FFjwhq__ctaWrapper",
  "description": "styles-module__FFjwhq__description",
  "logo": "styles-module__FFjwhq__logo",
  "qrCard": "styles-module__FFjwhq__qrCard",
  "textContent": "styles-module__FFjwhq__textContent",
  "title": "styles-module__FFjwhq__title",
});
